import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LangService } from './shared/service/lang.service';
import { ActivatedRoute } from '@angular/router';
import { translations } from './shared/service/trans';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'lcc';
  lang = 'en';
  translations = translations;
  t: any;

  constructor(
    private langService: LangService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit() {
    // 🔥 always get lang from URL (even with lazy modules)
    this.router.events.subscribe(() => {
      const lang = this.getLangFromUrl();

      if (lang) {
        this.langService.setLang(lang);
      }
    });

    // 🔥 update UI everywhere
    this.langService.lang$.subscribe((lang) => {
      this.lang = lang;
      this.t = this.translations[lang];
    });
  }
  getLangFromUrl(): string {
    let route = this.route.root;

    while (route.firstChild) {
      route = route.firstChild;
    }

    return route.snapshot.params['lang'] || 'en';
  }
  switchLang(lang: string) {
    this.langService.setLang(lang);

    const segments = this.router.url.split('/');
    segments[1] = lang; // replace lang in URL

    this.router.navigate(segments);
  }

  get tt() {
    return this.translations[this.lang];
  }
}
